export default __webpack_public_path__ + "static/media/blogDetail3.625969ae.png";